import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import config from "../../../content/meta/config";
import logo from "../../images/app-icons/icon.png";
import { useStaticQuery, graphql } from "gatsby";

const Seo = props => {
  const { data, facebook, pathPrefix, siteUrl } = props;
  const postTitle = ((data || {}).frontmatter || {}).title;
  const postDescription = ((data || {}).frontmatter || {}).description;
  const postSlug = ((data || {}).fields || {}).slug;

  const title = postTitle ? `${postTitle} | ${config.shortSiteTitle}` : config.siteTitle;
  const description = postDescription ? postDescription : config.siteDescription;
  //const image = config.siteImage;
  const image = siteUrl + logo;
  const url = encodeURI(siteUrl + pathPrefix + postSlug);

  const date = useStaticQuery(graphql`
    query {
      currentBuildDate {
        currentDate
      }
    }
  `);

  return (
    <Helmet
      htmlAttributes={{
        lang: config.siteLanguage,
        prefix: "og: http://ogp.me/ns#"
      }}
    >
      {/* General tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {/* OpenGraph tags */}
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta property="fb:app_id" content={facebook.appId} />
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary" />
      <meta
        name="twitter:creator"
        content={config.authorTwitterAccount ? config.authorTwitterAccount : ""}
      />
      <meta
        name="twitter:site"
        content={config.authorTwitterAccount ? config.authorTwitterAccount : ""}
      />

      <link
        rel="apple-touch-icon"
        href={siteUrl + "/icons/icon-48x48.png"}
        sizes="48x48"
      />
      <link
        rel="apple-touch-icon"
        href={siteUrl + "/icons/apple-icon-72x72.png"}
        sizes="72x72"
      />
      <link
        rel="apple-touch-icon"
        href={siteUrl + "/icons/icon-96x96.png"}
        sizes="96x96"
      />
      <link
        rel="apple-touch-icon"
        href={siteUrl + "/icons/icon-144x144.png"}
        sizes="144x144"
      />
      <link
        rel="apple-touch-icon"
        href={siteUrl + "/icons/icon-192x192.png"}
        sizes="192x192"
      />
      <link
        rel="apple-touch-icon"
        href={siteUrl + "/icons/icon-256x256.png"}
        sizes="256x256"
      />
      <link
        rel="apple-touch-icon"
        href={siteUrl + "/icons/icon-384x384.png"}
        sizes="384x384"
      />
      <link
        rel="apple-touch-icon"
        href={siteUrl + "/icons/icon-512x512.png"}
        sizes="512x512"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16×16"
        href={siteUrl + "/icons/favicon-16x16.png"}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32×32"
        href={siteUrl + "/icons/favicon-32x32.png"}
      />
    </Helmet>
  );
};

Seo.propTypes = {
  data: PropTypes.object,
  facebook: PropTypes.object.isRequired,
  siteUrl: PropTypes.string.isRequired,
  pathPrefix: PropTypes.string.isRequired
};

export default Seo;
